import Dashboard from "./Dashboard.vue";
import Login from "./Login.vue";
import NewUser from "./NewUser.vue";
import Clients from "./Clients.vue";
import Projects from "./Projects.vue";
import Client from "./Client.vue";
import Cards from "./Cards.vue";
import Project from "./Project.vue";
import Packages from "./Packages.vue";
import Package from "./Package.vue";
export default {
  Dashboard,
  Login,
  NewUser,
  Clients,
  Client,
  Projects,
  Project,
  Cards,
  Packages,
  Package,
};
